<form *ngFor="let company of gdpr.contactCompanies">
  <div class="c-alert c-alert-danger" *ngIf='dispalyTechError'>
    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
    <span style="font-weight: bold;" i18n>There was a problem. Please try again later or reach by</span><a style="font-weight: bold;" href="mailto:data.preferences@ihsmarkit.com" i18n>email</a>.
  </div>

  <div class="row clearfix" *ngIf="(company.isPrimaryCompany)">
    <div class="container-2 w-container">
      <div class="header1">
        <span i18n>Manage your data privacy</span>
      </div>
    </div>
    <div class="col-sm-12 gdpr-content-area">
      <!-- Begin Form -->
      <div class="gdpr-form">
        <p class="privacy" style="font-weight: 100;" i18n>The IHS Markit Database is a critical and widely used tool enabling investors and capital markets professionals to identify the appropriate counterparties in connection with market transactions and to assist capital markets participants with regulatory compliance efforts. The IHS Markit Database is relied upon globally by thousands of participants, including corporate investor relations and issuers, treasury and every major investment bank in the world, with the goal of making primary and secondary transactions most efficient. In short, IHS Markit’s solutions are critical to the effective operation of the global financial markets.</p>
        <p class="privacy" style="font-weight: bold;" i18n>Before setting your data preferences, please review the information that we have on file for you, as well as how your inclusion in our database benefits you.</p>
        <div class="columns w-row">
          <div class="column w-col col-lg-6 col-md-12 col-sm-12">
            <h1 class="headingwhitebox" i18n>What data we share</h1>
            <ul class="list w-list-unstyled">
              <li class="list-item-3 w-clearfix">
                <span class="cellheader" i18n>Your Name:</span></li>             
                <input type="email" class="tex" aria-describedby="name" placeholder="{{gdpr.firstName}} {{gdpr.middleName}} {{gdpr.lastName}}"  disabled> 
                
              <li class="list-item-3 w-clearfix"> 
                <span class="cellheader" i18n>Association:</span></li>
                <input type="text" class="tex"  placeholder="{{company.companyName}}" disabled *ngIf="company.isPrimaryCompany">
                <input type="text" class="tex" placeholder="Not available" disabled *ngIf="company.isPrimaryCompany && !company.companyName" i18n-placeholder>                
                
                <li class="list-item-8 w-clearfix">
                  <span class="cellheader" i18n>Function:</span></li>
                  <!-- <input type="text" class="tex" placeholder="{{company.jobFunction}}" disabled *ngIf="company.isPrimaryCompany && company.jobFunction">
                  <input type="text" class="tex" placeholder="Not available" disabled *ngIf="company.isPrimaryCompany && !company.jobFunction" i18n-placeholder>  -->
                  
                  <textarea class="area" placeholder="{{company.jobFunction}}" disabled *ngIf="company.isPrimaryCompany && company.jobFunction" ></textarea>
                  <textarea class="area" placeholder="Not available" disabled *ngIf="company.isPrimaryCompany && !company.jobFunction" i18n-placeholder></textarea>


              <li class="list-item-5 w-clearfix">
                <span class="cellheader" i18n>Business Email:</span></li>
                <input type="email" class="tex" placeholder="{{company.email}}" disabled *ngIf="company.isPrimaryCompany && company.email">
                <input type="email" class="tex" placeholder="Not available" disabled *ngIf="company.isPrimaryCompany && !company.email" i18n-placeholder>               
      

              <li class="list-item-6 w-clearfix">
                <span class="cellheader" i18n>Business Phone:</span></li>
                <input type="text" class="tex" placeholder="{{company.phoneNumberCountryCd}}-{{company.phoneNumber}}" disabled *ngIf="company.isPrimaryCompany && company.phoneNumber && company.phoneNumberCountryCd">
                <input type="text" class="tex" placeholder="{{company.phoneNumber}}" disabled *ngIf="company.isPrimaryCompany && company.phoneNumber && !company.phoneNumberCountryCd">
                <input type="text" class="tex" placeholder="Not available" disabled *ngIf="company.isPrimaryCompany && !company.phoneNumber" i18n-placeholder>
                                

              <li class="list-item-11 w-clearfix">
                <span class="cellheader" i18n>Business Fax:</span></li>
              <input type="text" class="tex" placeholder="{{company.faxNumberCountryCd}}-{{company.faxNumber}}" disabled *ngIf="company.isPrimaryCompany && company.faxNumber && company.faxNumberCountryCd">
              <input type="text" class="tex" placeholder="{{company.faxNumber}}" disabled *ngIf="company.isPrimaryCompany && company.faxNumber && !company.faxNumberCountryCd">
              <input type="text" class="tex" placeholder="Not available" disabled *ngIf="company.isPrimaryCompany && !company.faxNumber" i18n-placeholder>                


              <li class="list-item-10 w-clearfix">
                <span class="cellheader" i18n>Business Address:</span></li>
                <!-- <input type="text" class="tex" placeholder="{{primaryAddress}}" disabled *ngIf="primaryAddress">
                <input type="text" class="tex" placeholder="Not available" disabled *ngIf="!primaryAddress"> -->
                <textarea class="area" placeholder="{{primaryAddress}}" disabled *ngIf="primaryAddress" ></textarea>
                <textarea class="area" placeholder="Not available" disabled *ngIf="!primaryAddress" i18n-placeholder></textarea>
                

              <li class="list-item-7 w-clearfix">
                <span class="cellheader" i18n>Mailing Address:</span></li>
                <!-- <input type="text" class="tex" placeholder="{{mailingAddress}}"  disabled *ngIf="mailingAddress">
                <input type="text" class="tex" placeholder="Not available" disabled *ngIf="!mailingAddress"> -->                

                <textarea class="area"  placeholder="{{mailingAddress}}"  disabled *ngIf="mailingAddress"></textarea>
                <textarea class="area" placeholder="Not available" disabled *ngIf="!mailingAddress" i18n-placeholder></textarea>

                
            </ul>
            
            <button class="btn btn-default btn-block" style="margin-left: -14px;">
              <a href="mailto:data.preferences@ihsmarkit.com" class="update-btn" i18n>UPDATE MY INFORMATION</a>
            </button>
          </div>
          <div class="column-2 w-col col-lg-6 col-md-12 col-sm-12">
            <h1 class="headinggreen1" i18n>How this benefits you</h1>
            <h1 class="heading" i18n>Your data</h1>
            <p class="paragraphgreen mb-2" i18n>IHS Markit has collected your contact information from multiple sources, including public sources, counterparties throughout the global capital markets community, or by you directly, to be included within IHS Markit’s comprehensive database of capital markets contacts (“IHS Markit Database”). To learn more about the IHS Markit Database, how we process your information and what it is used for, please click <a i18n-href href="/#/privacy-notice" target="_blank" >here</a>.</p>
            <h1 class="heading" i18n>Why be included?</h1>
            <p class="paragraphgreen mb-3"  i18n>As a capital markets professional, you and your firm greatly benefit from having your information conveniently available in the IHS Markit &nbsp;Database and would be at a commercial disadvantage compared to your peers if your Information is not included.</p>
            <p class="paragraphgreen" i18n>As part of our commitment to data integrity and to maximizing the benefit to all participants in the global capital markets community, we encourage you to review the information contained in your profile.</p>
            <br>
          </div>
        </div>

      </div>
      <!-- Set your data privency preferences-->
  <div class="help_section" style=" clear: both; position: relative; background-color: #f0f1f2;">
    <div class="footer7 w-container">
      <div class="row" style="margin:10px;">
        <div class="col-lg-8 col-md-8 col-sm-12">
          <h1 class="header3" i18n>Set your data privacy preferences</h1></div><br>
      </div>
      <h3 class="privacy" style="font-weight: 100;" i18n>You may:</h3>
      <div class="div-block-3">
        <h3 class="heading3boxbalck" i18n>Elect to make no changes</h3>
        <p class="paragraph-3" i18n>We will continue to include the above information in our products. We may update this data from time to time, and you are free to change your data preferences at any time.</p>
        <div class="w-form">
          <form id="email-form" name="email-form" data-name="Email Form" class="checkboxselect"><label for="name" class="field-label" i18n>Name</label>
            <div class="w-checkbox">


              <input type="checkbox" class="w-checkbox-input" name="selectoption1" [checked]="selected1" value="T" id="Unchanged" (click)="toggleSelect1($event)" (change)="selected1 = !(selected1)">

              <label for="checkbox" class="checkbox-label w-form-label" i18n>I wish to keep my data preferences unchanged at this time</label></div>
          </form>
          <div class="w-form-done">
            <div i18n>Thank you! Your submission has been received!</div>
          </div>
          <div class="w-form-fail">
            <div i18n>Oops! Something went wrong while submitting the form.</div>
          </div>
        </div>
      </div>
      <div class="div-block4gray">
        <h3 class="heading3box" i18n>Remove your email address from IHS Markit products</h3>
        <p class="paragraph-3" i18n>Your other professional information may still appear in IHS Markit products. You may still receive emails from IHS Markit, but your email address will not be shared with our clients.</p><br>
        <p class="paragraph-3" style="font-weight: bold" i18n>You will:</p>
        <ul class="list-2">
          <li class="list-item" i18n>No longer receive research or liquidity/IOI inquiries from IHS Markit clients.</li>
          <li class="list-item-2" i18n>No longer receive roadshow invitations or event outreach from IHS Markit clients.</li>
        </ul>
        <div class="w-form">
          <form id="email-form" name="email-form" data-name="Email Form" class="checkboxselect"><label for="name" class="field-label" i18n>Name</label>
            <div class="w-checkbox">
              <input type="checkbox" class="form-check-input" class="w-checkbox-input" name="selectoption2" [checked]="selected2" value="D" id="Unsubscribe1" (click)="toggleSelect2and3($event)" (change)="selected2 = !(selected2)">
              <label for="checkbox-2" class="checkbox-label w-form-label" i18n>I wish to remove my email address from IHS Markit products</label></div>
          </form>
          <div class="w-form-done">
            <div i18n>Thank you! Your submission has been received!</div>
          </div>
          <div class="w-form-fail">
            <div i18n>Oops! Something went wrong while submitting the form.</div>
          </div>
        </div>
      </div>
      <div class="div-block-3 div-block4gray">
        <h3 class="heading3box"><span class="text-span-3" i18n>Unsubscribe from IHS Markit research-related emails</span></h3>
        <p class="paragraph-3" i18n>We will no longer contact you at the above email address in order to request updates to your professional profile. Your professional information, as listed above, may still appear in IHS Markit products and you may still receive verbal communication from us if necessary.</p>
        <ul class="list-2">
          <li class="list-item" i18n>No longer receive requests for compliance certifications needed by your broker for you to participate in IPOs and other trades.</li>
          <li class="list-item-2" i18n>No longer have updates to your professional profile for counterparties and other capital markets participants to view.</li>
        </ul>
        <div class="w-form">
          <form id="email-form" name="email-form" data-name="Email Form" class="checkboxselect"><label for="name" class="field-label" i18n>Name</label>
            <div class="w-checkbox">
              <input type="checkbox" class="w-checkbox-input" name="selectoption3" [checked]="selected3" value="B" id="Unsubscribe2" (click)="toggleSelect2and3($event)" (change)="selected3 = !(selected3)">
              <label for="checkbox-3" class="checkbox-label w-form-label" i18n>I wish to unsubscribe from IHS Markit research-related emails</label></div>
          </form>
          <div class="w-form-done">
            <div i18n>Thank you! Your submission has been received!</div>
          </div>
          <div class="w-form-fail">
            <div i18n>Oops! Something went wrong while submitting the form.</div>
          </div>
        </div>
      </div>
      <div class="div-block-3 div-block4gray">
        <h3 class="heading3box"><span class="text-span-4" i18n>Remove yourself from all IHS Markit products and communications</span></h3>
        <p class="paragraph-3" i18n>Your professional information will no longer be included in IHS Markit products. Additionally, we will no longer contact you for any reason at the email address listed above.</p>
        <ul class="list-2">
          <li class="list-item" i18n>No longer receive research or liquidity/IOI inquiries from IHS Markit clients.</li>
          <li class="list-item-2" i18n>No longer receive roadshow invitations or event outreach from IHS Markit clients.</li>
          <li class="list-item-2" i18n>No longer receive requests for compliance certifications needed by your broker for you to participate in IPOs and other trades.</li>
          <li class="list-item-2" i18n>No longer have updates to your professional profile for counterparties and other capital markets participants to view.</li>
        </ul>
        <div class="w-form">
          <form id="email-form" name="email-form" data-name="Email Form" class="checkboxselect"><label for="name" class="field-label" i18n>Name</label>
            <div class="w-checkbox">
              <input type="checkbox" class="w-checkbox-input" name="selectoption4" [checked]="selected4" value="F" id="opt-out" (click)="toggleSelect4($event)" (change)="selected4 = !(selected4)">
              <label for="checkbox-3" class="checkbox-label w-form-label" i18n>I wish to remove myself from all IHS Markit products and communications</label>
            </div>
          </form>
          <div class="w-form-done">
            <div i18n>Thank you! Your submission has been received!</div>
          </div>
          <div class="w-form-fail">
            <div i18n>Oops! Something went wrong while submitting the form.</div>
          </div>
        </div>       
      </div>          
     
      <div class="divsubmit" *ngIf="!disableSubmit" style="position: relative; top: 0px;">
        <button type="submit" class="submitbutton w-button" (click)="gdprOpted($event)" i18n>SUBMIT</button>
      </div>
      
      <div class="divfooter w-clearfix">
        <span style="margin-left: 5px; color: #fff; font-size: 12px;" i18n>Copyright © 2023 IHS Markit. All Rights Reserved</span>        
        <a i18n-href href="/#/privacy-notice" target="_blank" class="footerlink" ><span style="font-size: 12px;" data-ix="new-interaction" i18n>Privacy Notice</span></a>
        <a href="{{apacenprivacynotice}}" target="_blank" [ngStyle]="{'display':disableENPrivacy}" class="footerlink"><span style="font-size: 12px;" data-ix="new-interaction">Privacy Notice</span></a>
      </div>
    </div>
  </div>

      <div class="gdpr-footer-graphic">
        <span i18n>IHS Markit Privacy Policies</span>
      </div>
      <!-- / End Footer graphic -->
    </div>
  </div>
</form>
<div class="my-container">
  <ngx-loading [show]="loading"></ngx-loading>
</div>

<div class="col-lg-12 col-md-12 col-sm-12 c-modal c-modal-fade c-modal-in" [ngStyle]="{'display':display}">
  <div class="c-modal-dialog">
    <div class="c-modal-content">
      <div class="c-modal-header head-bg">
        <div class="c-modal-title c-header-md head-title">
          <span><img src="assets/icon_warning.svg" alt="Warning" style="width: 25px;"></span>
          &nbsp;<span style="font-weight: bold" i18n>By continuing, your professional information will no longer be accessible to IHS Markit clients.</span>          
        </div>
        <button type="button" class="c-modal-close" (click)="modalClose()">
        </button>
      </div>
      <div class="c-modal-body c-modal-body-content" >

        <br />
        <div class="c-body-text c-text-md">
          <p i18n>Please be aware that capital markets professionals use IHS Markit products and services to send a wide variety of important market or transaction-related communications to market participants like you. </p>
          <p i18n>With your selection below, you agree NOT to be able to receive any of these communications, which include research or liquidity/IOI inquiries, roadshow invitations, and event outreach. </p>
          <p i18n>Furthermore, you will no longer receive requests for compliance certifications needed by your broker for you to participate in IPOs or other trades. IHS Markit will no longer contact you under any circumstances.</p>
        </div>
          <div>
            <div class="form-group gdpr-modal-btn">
              <button class="c-btn c-btn-success gdpr-modal-close-btn" type="button" (click)="modalClose()" style="border-radius: 4px;" i18n>Cancel and return to my preferences </button>
              <button class="c-btn c-btn-default gdpr-modal-continue-btn" type="button" (click)="confirmToOptOut()" style="border-radius: 4px;" i18n>I understand and wish to continue</button>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>


<div class="col-lg-12 col-md-12 col-sm-12 c-modal c-modal-fade c-modal-in" [ngStyle]="{'display':displayWarningShow}">
  <div class="c-modal-dialog">
    <div class="c-modal-content">
      <div class="c-modal-header head-bg">
        <div class="c-modal-title c-header-md head-title">
          
          <span><img src="assets/icon_warning.svg" alt="Warning" style="width: 25px;"></span>
          <span style='color:red;margin-right:0.25em; display:inline-block;'></span>
          <span i18n>ALERT</span>          
        </div>        
      </div>
      <div class="c-modal-body c-modal-body-content" >

        <br />
        <div class="c-body-text c-text-md">
          <div class="gdpr-text-already"><span style="font-weight: bold;" i18n>Please make a selection from the options above.</span>
          </div>         

          <div style="position: relative; top: 0px; text-align: center!important;">
            <button type="submit" class="submitbutton w-button" (click)="modalCloseOkWarning()" i18n>OK</button>
          </div>

        </div> 
      </div>
    </div>
  </div>
</div>


<div class="col-lg-12 col-md-12 col-sm-12 c-modal c-modal-fade c-modal-in" [ngStyle]="{'display':disableSubmitdisplay}">
  <div class="c-modal-dialog">
    <div class="c-modal-content">
      <div class="c-modal-header head-bg">
        <div class="c-modal-title c-header-md head-title">
          
          <span><img src="assets/icon_warning.svg" alt="Warning" style="width: 25px;"></span>
          <span style='color:red;margin-right:0.25em; display:inline-block;'></span>
          <span i18n>ALERT</span>          
        </div>        
      </div>
      <div class="c-modal-body c-modal-body-content" >

        <br />
        <div class="c-body-text c-text-md">
          <div class="gdpr-text-already"><span style="font-weight: bold;" i18n >You have already selected option {{statustobe}}</span>
          <p i18n style="line-height: 20px; text-align: left;">If that selection was in error or if you wish to change your selection, please email the 
            <a href="mailto:data.preferences@ihsmarkit.com">IHS Markit Support Team</a>.</p>
          </div>         

          <div style="position: relative; top: 0px; text-align: center!important;">
            <button type="submit" class="submitbutton w-button" (click)="modalCloseOkbutton()" i18n>OK</button>
          </div>

        </div> 
      </div>
    </div>
  </div>
</div>
